// После деплоя старая вкладка просит файлы прошлой сборки: их уже нет, а сервер отвечает index.html.
// То же в dev, когда Vite пересобрал зависимости. Лечится одной перезагрузкой страницы
const KEY = 'rpso-chunk-reload-at';
const MIN_INTERVAL_MS = 10_000;

/** Ошибка загрузки кусочка сборки (динамический import) — Chrome, Firefox, Safari */
export const isChunkLoadError = (error: unknown) =>
  error instanceof Error &&
  /dynamically imported module|Importing a module script failed|error loading dynamically imported module|MIME type/i.test(
    error.message,
  );

/** Перезагружает страницу, но не чаще раза в 10 с — если сборка битая, не уйдём в бесконечный цикл */
export const reloadOnce = (): boolean => {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? 0);
    if (Date.now() - last < MIN_INTERVAL_MS) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    // sessionStorage недоступен (приватный режим) — перезагрузка всё равно безопаснее ошибки
  }
  window.location.reload();
  return true;
};
